import React, { useState, useEffect } from 'react';
import useUsers from '../../context/UsersContext';
import FormFields from './FormFields';
import { FormHeaderUI, FormButtonPanelUI, DeleteDialogUI, DialogUI } from '../Interface';
import Yup from '../../utils/yup';
import dayjs from 'dayjs';
import { isEqual } from 'lodash';
import { Formik, Form } from 'formik';
import { NotificationType } from '../../config';
import addNotification from '../../utils/addNotification';
import { getDynVals } from '../../utils/DynHelper';
import taskFeedbackService from '../../service/taskFeedback.service';
import TaskFeedbackTabs from './TaskFeedbackTabs';
import { useParams } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import MarkChatReadIcon from '@mui/icons-material/MarkChatRead';
import appService from '../../service/app.service';
import masterDataService from '../../service/masterData.service';
import { generateAutocompleteItems } from '../../utils/helper';
import operationService from '../../service/operation.service';
import History from '../History/History';
import HistoryDialog from '../History/HistoryDialog';
import useParam from '../../context/ParamContext';

export const TaskFeedbackPage = ({ taskFeedbackState, dialog }) => {
  const {
    setRefetchTable,
    selectedValues,
    setSelectedValues,
    viewField,
    setViewField,
    operatorsDisabled,
    setOperatorsDisabled,
    submenu,
    canEdit,
    autocompleteData,
    autocompleteOptions,
    dynProps,
    setDynProps,
    dynLoading,
    setDynLoading,
    setRowSelectionModel,
    setAutocompleteData,
    setAutoCompleteOptions,
    setLoading,
  } = taskFeedbackState;
  const { params } = useParam();
  const { id } = useParams();
  const { user, getRole } = useUsers();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [editButtonVisible, setEditButtonvisible] = useState(true);
  const [addField, setAddField] = useState(true);
  const [showDialog, setShowDialog] = useState(false);

  const [defaultValues, setDefaultValues] = useState({});
  const [defaultSelectedValues, setDefaultSelectedValues] = useState({});
  const [initValues, setInitValues] = useState({});
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [roles, setRoles] = useState({});

  const def = {
    name: '',
    startDate: dayjs(new Date()),
    endDate: dayjs(new Date()).add(1, 'hour'),
    duration: 1,
    typeId: null,
    statusId: null,
    priorityId: null,
    relevantDepartmentId: null,
    solutionProposal: '',
    description: '',
    taskFeedbackAttachment: [],
    operationId: null,
    itemCode: '',
    projectId: null,
    projectOrderNumber: '',
  };

  useEffect(() => {
    setDefaultValues(def);
  }, []);

  useEffect(() => {
    if (Object.keys(user).length > 0) {
      const roles = getRole('FFEDBACK_KANBAN_ONLY_KANBAN_STATUS_SELECT');

      setRoles(roles);
    }
  }, [user]);

  useEffect(() => {
    submenu && initDefaultValues();
  }, [submenu]);

  useEffect(() => {
    if (Object.keys(autocompleteData).length > 0) {
      setDefaultValues((prev) => {
        return {
          ...prev,
          typeId: autocompleteData?.type?.defaultValue ?? null,
          statusId: autocompleteData?.status?.defaultValue ?? null,
          priorityId: autocompleteData?.priority?.defaultValue ?? null,
        };
      });

      setDefaultSelectedValues((prev) => {
        return {
          ...prev,
          type: autocompleteData?.type?.defItem,
          status: autocompleteData?.status?.defItem,
          priority: autocompleteData?.priority?.defItem,
        };
      });
    }
  }, [autocompleteData]);

  useEffect(() => {
    if (dialog?.data) {
      setDefaultValues((prev) => {
        return {
          ...prev,
          ...dialog.data,
          createdBy: dialog.data.createdBy,
        };
      });
    } else if (Object.keys(user).length > 0) {
      setDefaultValues((prev) => {
        return {
          ...prev,
          createdBy: user.userId,
        };
      });
    }
  }, [user, dialog]);

  useEffect(() => {
    setSelectedValues(defaultSelectedValues);
  }, [defaultSelectedValues]);

  useEffect(() => {
    if (id) {
      getRowById();
    } else {
      setSelectedValues(defaultSelectedValues);
    }
  }, [defaultSelectedValues, id]);

  const getRowById = () => {
    taskFeedbackService.getRow(id).then((data) => {
      setSelectedValues(data);
    });
  };

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .typeToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .statusToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .usersToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .priorityToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .userGroupsToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    if (dialog?.data) {
      promiseArray.push(
        new Promise((resolve, reject) => {
          operationService
            .getOperationByBaseLine(dialog.data.baseLine)
            .then((data) => {
              resolve(data);
            })
            .catch((e) => {
              reject(e);
            });
        })
      );
    } else {
      promiseArray.push(
        new Promise((resolve, reject) => {
          masterDataService
            .operationToForm()
            .then((data) => {
              resolve(data);
            })
            .catch((e) => {
              reject(e);
            });
        })
      );
    }

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .projectToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          type: resp[0],
          status: resp[1],
          user: resp[2],
          priority: resp[3],
          relevantDepartment: resp[4],
          operations: resp[5],
          project: resp[6],
        };
        setAutocompleteData(aData);

        const acOptions = {
          type: generateAutocompleteItems(aData.type.typeItems, 'itemName', 'itemId'),
          status: generateAutocompleteItems(aData.status.statusItems, 'itemName', 'itemId'),
          user: generateAutocompleteItems(aData.user, 'userName', 'userId'),
          priority: generateAutocompleteItems(aData.priority.priorityListItems, 'itemName', 'itemId'),
          relevantDepartment: generateAutocompleteItems(aData.relevantDepartment, 'name', 'id'),
          operations: generateAutocompleteItems(aData.operations, 'operationName', 'operationId'),
          project: generateAutocompleteItems(aData.project, ['projectName', 'orderNumber'], 'projectId'),
        };
        setAutoCompleteOptions(acOptions);
        setLoading(false);
      })
      .finally(() => {
        //hideLoader();
      });
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    startDate: Yup.string().required(),
    endDate: Yup.string().required(),
    duration: Yup.number().positive().required().min(1),
    typeId: Yup.string().required(),
    statusId: Yup.string().required(),
    priorityId: Yup.string().required(),
    relevantDepartmentId:
      params.HIDE_TASKFEEDBACK_RELEVANT_DEP_FIELD !== 'Y' ? Yup.string().required() : Yup.string().nullable(),
    solutionProposal: Yup.string().nullable(),
    description: Yup.string().nullable(),
    operationId: Yup.string().nullable(),
    itemCode: Yup.string().nullable(),
    projectId: Yup.string().nullable(),
    projectOrderNumber: Yup.string(),
  });

  const handleSubmit = (values) => {
    if (!editButtonVisible) {
      updateObject(values);
    } else if (!addField || dialog) {
      handleInsertObject(values);
    }
  };

  useEffect(() => {
    if (Object.keys(selectedValues).length > 0) {
      if (!isEqual(defaultSelectedValues, selectedValues)) {
        valuesToForm();
        setOperatorsDisabled(false);
      } else {
        setOperatorsDisabled(true);
        setInitValues(defaultValues);
      }
    }
  }, [selectedValues]);

  useEffect(() => {
    if (dialog) {
      setViewField(true);
    }
  }, [dialog?.handleClose]);

  const valuesToForm = () => {
    const {
      name,
      startDate,
      endDate,
      duration,
      typeId,
      createdBy,
      statusId,
      priorityId,
      relevantDepartmentId,
      productionId,
      prodOperationId,
      solutionProposal,
      description,
      taskFeedbackAttachment,
      operationId,
      itemCode,
      projectId,
    } = selectedValues;

    setInitValues({
      name,
      startDate: dayjs(startDate),
      endDate: dayjs(endDate),
      duration,
      typeId,
      createdBy,
      statusId,
      priorityId,
      relevantDepartmentId,
      dynamicFields: getDynVals(dynProps, selectedValues.dynamicProperties),
      productionId,
      prodOperationId,
      solutionProposal: solutionProposal ?? def.solutionProposal,
      description: description ?? def.description,
      taskFeedbackAttachment,
      operationId,
      itemCode,
      projectId,
      projectOrderNumber: selectedValues.project?.orderNumber || '',
    });
  };

  const updateObject = (values) => {
    const updData = {
      ...values,
      duration: parseFloat(values.duration),
      startDate: dayjs(values.startDate).toISOString(),
      endDate: dayjs(values.endDate).toISOString(),
    };

    updData.existingFiles = updData.taskFeedbackAttachment?.map((f) => f.name);

    const formData = new FormData();
    formData.append('data', JSON.stringify(updData));

    if (updData.taskFeedbackAttachment) {
      for (const file of updData.taskFeedbackAttachment) {
        if (file instanceof File) {
          formData.append('files', file);
        }
      }
    }

    taskFeedbackService.updateRow(formData, selectedValues.id).then(() => {
      addNotification({
        content: 'Sikeres módosítás!',
        type: NotificationType.SUCCESS,
      });

      setRefetchTable(true);
      setEditButtonvisible(true);
      setViewField(true);
      if (dialog) {
        dialog.handleClose();
        dialog.setTaskChanged(true);
      }
    });
  };

  const handleInsertObject = (values) => {
    const insertObject = {
      ...values,
      duration: parseFloat(values.duration),
      startDate: dayjs(values.startDate).toISOString(),
      endDate: dayjs(values.endDate).toISOString(),
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(insertObject));

    if (insertObject.taskFeedbackAttachment) {
      for (const file of insertObject.taskFeedbackAttachment) {
        formData.append('files', file);
      }
    }

    taskFeedbackService.createRow(formData).then((data) => {
      addNotification({
        content: 'Sikeres mentés!',
        type: NotificationType.SUCCESS,
      });
      setRefetchTable(true);
      setAddField(true);
      setViewField(true);
      setRowSelectionModel(data.id);
      setSelectedValues(data);

      if (dialog) {
        dialog.handleClose();
      }
    });
  };

  const handleRemoveElement = async () => {
    taskFeedbackService.deleteRow(selectedValues.id).then(() => {
      addNotification({
        content: 'Sikeres törlés!',
        type: NotificationType.WARNING,
      });
      setRefetchTable(true);
      setShowDeleteDialog(false);
      setSelectedValues(defaultSelectedValues);

      if (dialog) {
        dialog.handleClose();
        dialog.setTaskChanged(true);
      }
    });
  };

  const onAddClick = () => {
    setSelectedValues(defaultSelectedValues);
    setInitValues(defaultValues);
    setViewField(false);
    setAddField(false);
  };

  const onModifyClick = () => {
    setViewField(false);
    setEditButtonvisible(false);
  };

  const onDeleteClick = () => {
    setShowDeleteDialog(true);
  };

  const onCopyClick = () => {
    setViewField(false);
    setAddField(false);
  };

  const handleUpdateReadAt = () => {
    appService.updateReadAt(selectedValues.messages.id).then(() => {
      getRowById();
    });
  };

  const isDisabled = dialog ? (dialog.feedbackIsUpdate ? viewField && editButtonVisible : false) : viewField;

  return (
    <>
      <div className="h-full overflow-auto custom-scrollbar">
        <div className="flex items-center flex-wrap justify-between">
          <FormHeaderUI
            addClick={!dialog ? onAddClick : null}
            addDisabled={!viewField || !canEdit}
            modClick={!dialog || dialog?.feedbackIsUpdate ? onModifyClick : null}
            modDisabled={!viewField || operatorsDisabled || !canEdit}
            deleteClick={!dialog || dialog?.feedbackIsUpdate ? onDeleteClick : null}
            deleteDisabled={!viewField || operatorsDisabled || !canEdit}
            copyClick={!dialog ? onCopyClick : null}
            copyDisabled={!viewField || operatorsDisabled || !canEdit}
          />
          <div>
            <History disabled={operatorsDisabled} onClick={() => setHistoryDialogOpen(!historyDialogOpen)} />
          </div>
          {id && selectedValues?.messages && (
            <Box display="flex" alignItems="center" sx={{ cursor: 'pointer' }} onClick={handleUpdateReadAt}>
              <IconButton>
                <MarkChatReadIcon />
              </IconButton>
              <Typography>Elolvastam</Typography>
            </Box>
          )}
        </div>

        <Formik
          initialValues={initValues}
          validationSchema={validationSchema}
          validateOnChange={false}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ resetForm, setFieldValue }) => (
            <Form>
              <FormFields
                viewField={isDisabled}
                submenuId={submenu}
                selectedValues={selectedValues}
                autocompleteOptions={autocompleteOptions}
                dialog={dialog}
                editButtonVisible={editButtonVisible}
                autocompleteData={autocompleteData}
                roles={roles}
              />

              <TaskFeedbackTabs
                disabled={isDisabled}
                setRefetchTable={setRefetchTable}
                addField={isDisabled}
                selectedValues={selectedValues}
                setSelectedValues={setSelectedValues}
                user={user}
                dynLoadingState={{ dynLoading, setDynLoading }}
                dynProperties={{ dynProps, setDynProps }}
                setDefaultValues={setDefaultValues}
                setFieldValue={setFieldValue}
                submenuId={submenu}
              />

              <FormButtonPanelUI
                onCancelClick={() => {
                  setViewField(true);
                  setEditButtonvisible(true);
                  setAddField(true);
                  resetForm();
                  if (dialog) {
                    dialog.handleClose();
                  }
                }}
                disabled={
                  dialog
                    ? dialog.feedbackIsUpdate
                      ? viewField && editButtonVisible
                      : false
                    : editButtonVisible && addField
                }
              />
            </Form>
          )}
        </Formik>
      </div>

      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
      />

      <DialogUI
        open={showDialog}
        headerContent={'Feladat lejelentő'}
        fullWidth={true}
        onClose={() => setShowDialog(false)}
      ></DialogUI>

      <HistoryDialog
        open={historyDialogOpen}
        handleClose={() => {
          setHistoryDialogOpen(false);
        }}
        formId={submenu}
        lineId={selectedValues.id}
        fieldConfig={[]}
        isDateTimeFormat={true}
      />
    </>
  );
};
